var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import classNames from 'classnames';
import styles from './Search.module.css';
import baseStyles from '../Base.module.css';
import { filterInputValue, isMobileDevice } from '../utils';
function useAvailableOptions(query, options, selected) {
    var _a = __read(React.useState([]), 2), availableOptions = _a[0], setAvailableOptions = _a[1];
    var _b = __read(React.useState(false), 2), isLoadingOptions = _b[0], setIsLoadingOptions = _b[1];
    var timeout = React.useRef();
    var firstRender = React.useRef(true);
    React.useEffect(function () {
        if (typeof options === 'function') {
            window.clearTimeout(timeout.current);
            if (query || firstRender.current) {
                firstRender.current = false;
                timeout.current = window.setTimeout(function () {
                    setIsLoadingOptions(true);
                    options(query)
                        .then(setAvailableOptions)
                        .then(function () { return setIsLoadingOptions(false); });
                }, 500);
            }
        }
    }, [options, query]);
    React.useEffect(function () {
        var isSelected = function (option) {
            if (selected instanceof Array) {
                var selectedIds = new Set(selected.map(function (_a) {
                    var id = _a.id;
                    return id;
                }));
                return selectedIds.has(option.id);
            }
            else if (typeof selected === 'object') {
                return selected.id === option.id;
            }
            else {
                return false;
            }
        };
        var queryRegexp = new RegExp(query, 'i');
        var shouldBeVisible = function (option) {
            return !isSelected(option) && queryRegexp.test(option.value);
        };
        if (typeof options === 'object') {
            setAvailableOptions(options.filter(shouldBeVisible));
        }
    }, [options, selected, query]);
    return { availableOptions: availableOptions, isLoadingOptions: isLoadingOptions };
}
function Chip(props) {
    return (React.createElement("div", { tabIndex: -1, className: styles.selected },
        props.name,
        React.createElement("button", { type: 'button', tabIndex: -1, className: styles.delete, onClick: props.handleDelete })));
}
function Dropdown(props) {
    var options = props.options, handleClick = props.handleClick, isLoadingOptions = props.isLoadingOptions;
    return (React.createElement("div", { className: styles.dropdown, tabIndex: -1 }, isLoadingOptions ? (React.createElement("div", { className: styles.listInfoItem }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...")) : options.length ? (options.map(function (option, index) { return (React.createElement("div", { key: index, className: styles.listItem, onClick: function (event) {
            event.stopPropagation();
            handleClick(option);
        } }, option.value)); })) : (React.createElement("div", { className: styles.listInfoItem }, "\u041D\u0435\u0442 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"))));
}
var Wrapper = function (props) {
    return (React.createElement("div", { className: baseStyles.control },
        props.label && (React.createElement("label", { className: baseStyles.label, htmlFor: props.id }, props.label)),
        React.createElement("div", { className: baseStyles.inputContainer },
            props.children,
            props.isValid === false && props.validationMessage && (React.createElement("div", { className: baseStyles.validationMessage }, props.validationMessage)))));
};
// TODO: make components DRY
export function MultiSearch(props) {
    var _a;
    var options = props.options, selected = props.selected, updateSelected = props.updateSelected, placeholder = props.placeholder;
    var _b = __read(React.useState(false), 2), dropdownVisible = _b[0], setDropdownVisible = _b[1];
    var _c = __read(React.useState(''), 2), query = _c[0], setQuery = _c[1];
    var handleContainerClick = function () {
        inputRef.current.focus();
    };
    var handleChange = function (event) {
        filterInputValue(event, setQuery);
    };
    var handleInputFocus = function () {
        if (!dropdownVisible) {
            setDropdownVisible(true);
            if (isMobileDevice()) {
                setTimeout(function () {
                    containerRef.current.scrollIntoView({ block: 'start' });
                }, 100);
            }
        }
    };
    var handleInputBlur = function (event) {
        var relatedTarget = event.relatedTarget;
        var container = containerRef.current;
        if (relatedTarget && relatedTarget.parentElement === container) {
            inputRef.current.focus();
        }
        else {
            setDropdownVisible(false);
        }
    };
    var handleInputKeydown = function (event) {
        if (event.key === 'Escape') {
            setDropdownVisible(false);
            inputRef.current.blur();
        }
    };
    var addToSelected = function (option) {
        updateSelected(__spreadArray(__spreadArray([], __read(selected), false), [option], false));
        setQuery('');
    };
    var deleteFromSelected = function (option) {
        var index = selected.findIndex(function (selected) { return selected.id === option.id; });
        var selectedUpdated = selected.slice();
        selectedUpdated.splice(index, 1);
        updateSelected(selectedUpdated);
    };
    var _d = useAvailableOptions(query, options, selected), availableOptions = _d.availableOptions, isLoadingOptions = _d.isLoadingOptions;
    var containerRef = React.useRef(null);
    var inputRef = React.useRef(null);
    return (React.createElement(Wrapper, { label: props.label, id: props.id, isValid: props.isValid, validationMessage: props.validationMessage },
        React.createElement("div", { tabIndex: -1, ref: containerRef, className: classNames(baseStyles.controlInput, styles.search, (_a = {},
                _a[baseStyles.controlInputInvalid] = props.isValid === false,
                _a)), onClick: handleContainerClick },
            selected.map(function (item) { return (React.createElement(Chip, { name: item.value, key: item.id, handleDelete: function (event) {
                    deleteFromSelected(item);
                    if (!dropdownVisible)
                        event.stopPropagation();
                } })); }),
            React.createElement("input", { value: query, ref: inputRef, placeholder: placeholder, id: props.id, className: classNames(baseStyles.controlInput, styles.queryInputMulti), onChange: handleChange, onFocus: handleInputFocus, onBlur: handleInputBlur, onKeyDown: handleInputKeydown }),
            dropdownVisible && (React.createElement(Dropdown, { options: availableOptions, isLoadingOptions: isLoadingOptions, handleClick: addToSelected })))));
}
export function SingleSearch(props) {
    var _a, _b;
    var _c, _d;
    var _e = __read(React.useState(false), 2), active = _e[0], setActive = _e[1];
    var _f = __read(React.useState(''), 2), query = _f[0], setQuery = _f[1];
    var containerRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var initialRender = React.useRef(true);
    React.useEffect(function () {
        if (initialRender.current) {
            initialRender.current = false;
        }
        else {
            if (!active) {
                inputRef.current.blur();
                setQuery('');
            }
        }
    }, [active]);
    var _g = useAvailableOptions(query, props.options, props.selected), availableOptions = _g.availableOptions, isLoadingOptions = _g.isLoadingOptions;
    var handleContainerClick = function () {
        if (props.disabled)
            return;
        setActive(true);
        // focus on ios safari: https://stackoverflow.com/a/16601288
        inputRef.current.focus();
        if (isMobileDevice()) {
            // to avoid jitter
            setTimeout(function () {
                containerRef.current.scrollIntoView({ block: 'start' });
            }, 100);
        }
    };
    var handleChange = function (event) {
        filterInputValue(event, setQuery);
    };
    var handleBlur = function (event) {
        var relatedTarget = event.relatedTarget;
        var container = containerRef.current;
        if (relatedTarget && relatedTarget.parentElement === container) {
            inputRef.current.focus();
        }
        else {
            setActive(false);
        }
    };
    var handleKeyDown = function (event) {
        if (event.key === 'Escape') {
            setActive(false);
        }
    };
    var handleItemSelect = function (option) {
        props.updateSelected(option);
        setActive(false);
    };
    var handleDeleteItem = function (event) {
        event.stopPropagation();
        props.updateSelected();
        setActive(false);
    };
    return (React.createElement(Wrapper, { label: props.label, id: props.id, isValid: props.isValid, validationMessage: props.validationMessage },
        React.createElement("div", { ref: containerRef, tabIndex: -1, className: classNames(baseStyles.controlInput, styles.singleSearch, (_a = {},
                _a[baseStyles.controlInputInvalid] = props.isValid === false,
                _a[styles['singleSearch--selected']] = props.selected,
                _a[styles['singleSearch--disabled']] = props.disabled,
                _a)), onClick: handleContainerClick },
            React.createElement("input", { ref: inputRef, value: query, placeholder: (_d = (_c = props.selected) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : props.placeholder, id: props.id, className: classNames(baseStyles.controlInput, styles.queryInput, (_b = {},
                    _b[styles['queryInput--selected']] = props.selected,
                    _b)), onChange: handleChange, onBlur: handleBlur, onKeyDown: handleKeyDown, disabled: props.disabled }),
            active && (React.createElement(Dropdown, { options: availableOptions, isLoadingOptions: isLoadingOptions, handleClick: handleItemSelect })),
            props.selected && (React.createElement("button", { type: 'button', className: styles.deleteButton, onClick: handleDeleteItem, disabled: props.disabled })))));
}
